import React from "react";
import styles from "./Review.module.css";
import Link from "next/link";
import { useTranslation } from "../../context/TranslationContext";
import { googleReviews } from "./GoogleReviewsData";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Virtual, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const GoogleLogo = ({ className }) => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={className || "w-6 h-6"}
  >
    <g transform="matrix(1, 0, 0, 1, 27.009001, -39.238998)">
      <path d="M -3.264 51.509 C -3.264 50.719 -3.334 49.969 -3.454 49.239 L -14.754 49.239 L -14.754 53.749 L -8.284 53.749 C -8.574 55.225 -9.424 56.474 -10.686 57.324 L -10.686 60.325 L -6.842 60.325 C -4.608 58.235 -3.264 55.159 -3.264 51.509 Z" fill="#4285F4"/>
      <path d="M -14.754 63.239 C -11.516 63.239 -8.801 62.157 -6.821 60.324 L -10.685 57.323 C -11.761 58.044 -13.138 58.469 -14.754 58.469 C -17.869 58.469 -20.518 56.364 -21.464 53.535 L -25.276 53.535 L -25.276 56.453 C -23.414 60.188 -19.542 63.239 -14.754 63.239 Z" fill="#34A853"/>
      <path d="M -21.464 53.535 C -21.711 52.801 -21.838 52.016 -21.838 51.213 C -21.838 50.407 -21.711 49.623 -21.464 48.889 L -21.464 45.971 L -25.276 45.971 C -26.046 47.508 -26.488 49.225 -26.488 51.213 C -26.488 53.197 -26.046 54.918 -25.276 56.453 L -21.464 53.535 Z" fill="#FBBC05"/>
      <path d="M -14.754 43.955 C -12.983 43.955 -11.396 44.57 -10.146 45.749 L -6.741 42.34 C -8.802 40.418 -11.516 39.239 -14.754 39.239 C -19.542 39.239 -23.414 42.29 -25.276 46.025 L -21.464 48.943 C -20.518 46.113 -17.869 43.955 -14.754 43.955 Z" fill="#EA4335"/>
    </g>
  </svg>
);

const Review = ({ data }) => {
  const {
    homeReviewLeftTitleSmall,
    homeReviewLeftTitle,
    homeReviewLeftText,
    reviews: reviewsText,
    allReviews,
    googleReviewsTitle,
    googleReviewsCount,
    viewAllReviews,
    writeReviewShort,
  } = useTranslation();

  return (
    <div className="flex w-full">
      <div className="flex-auto bg-teklif-1"></div>
      <div className="flex container flex-col lg:flex-row px-0">
        
        {/* Left Side: Villa Bulma Sihirbazı */}
        <div className="bg-teklif-gra w-full lg:w-1/3 pt-16 pb-14 text-white flex flex-col items-center lg:items-start content-center px-12 lg:pl-[1.1rem] lg:pr-0 2xl:pl-0">
          <span className="text-xl">{homeReviewLeftTitleSmall || "Yardıma mı ihtiyacın var?"}</span>
          <span className="text-3xl text-center lg:text-left font-bold -mt-1">
            {homeReviewLeftTitle || "Villa Bulma Sihirbazı"}
          </span>
          <p className="opacity-80 mt-3 lg:pr-24 text-sm text-center lg:text-left">
            {homeReviewLeftText || "Seçmekte zorlanıyor musunuz? Formu doldurun, sizin için en uygun evleri listeleyip sunalım."}
          </p>
          <Link href={data?.url || "/iletisim"}>
            <a
              title={data?.title || "Formu Doldur"}
              className="bg-brand-blue-2 font-bold text-sm text-white py-4 px-8 mt-12 hover:opacity-90 transition-opacity"
            >
              {data?.kisa_baslik || "Teklif Al"}
            </a>
          </Link>
        </div>

        {/* Right Side: Google Reviews */}
        <div
          className={
            "lg:w-2/3 bg-white relative lg:pl-8 xl:pl-16 lg:pt-1 flex flex-col justify-between lg:pr-[1.1rem] 2xl:pr-0 " +
            styles.ReviewWrap
          }
        >
          <div className="flex flex-col lg:flex-row justify-between items-center bg-primary lg:bg-white pt-8 pb-8 lg:py-8 lg:pr-8">
            <div className="flex flex-col mb-4 lg:mb-0">
              <div className="flex items-center justify-center lg:justify-start gap-3">
                <div className="bg-white p-2 rounded-full shadow-sm hidden lg:block border border-gray-100">
                  <GoogleLogo className="w-6 h-6" />
                </div>
                <span className="text-center lg:text-left text-white lg:text-orange font-bold text-lg lg:text-2xl">
                  {googleReviewsTitle}
                </span>
              </div>
              <div className="flex items-center justify-center lg:justify-start gap-2 mt-2">
                <span className="text-white lg:text-gray-800 font-bold text-xl">4.8</span>
                <div className="flex text-yellow-400">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="w-5 h-5 fill-current" viewBox="0 0 24 24">
                      <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                    </svg>
                  ))}
                </div>
                <span className="text-white lg:text-gray-500 text-sm font-medium ml-1">{googleReviewsCount}</span>
              </div>
            </div>
            
            <a
              href="https://g.page/r/Cc84qp7cJY5HEBM/review"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-primary lg:bg-primary lg:text-white border border-primary font-bold text-xs py-3 px-6 hover:bg-orange hover:text-white hover:border-orange transition-colors flex items-center gap-2"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path></svg>
              {writeReviewShort}
            </a>
          </div>

          <div className="relative pb-12 pr-0 lg:pr-8 mt-2">
            <div className="px-10 h-full">
              <Swiper
                spaceBetween={20}
                slidesPerView={1}
                navigation={{ nextEl: '.review-next', prevEl: '.review-prev' }}
                pagination={{ el: '.review-pagination', clickable: true }}
                modules={[Autoplay, Pagination, Virtual, Navigation]}
                autoplay={{ delay: 4000, disableOnInteraction: false }}
                breakpoints={{
                  768: { slidesPerView: 2 },
                }}
                className="h-full"
              >
                {googleReviews.slice(0, 15).map((review, i) => (
                  <SwiperSlide key={i} virtualIndex={i} className="h-auto">
                    <div className="bg-gray-50 p-6 h-full flex flex-col border border-gray-100 rounded">
                      <div className="flex justify-between items-start mb-3">
                        <div className="flex text-yellow-400">
                          {[...Array(5)].map((_, i) => (
                            <svg key={i} className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                              <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                            </svg>
                          ))}
                        </div>
                        <div className="flex items-center gap-1.5 bg-white border border-gray-200 px-2.5 py-1 rounded-full shadow-sm">
                           <GoogleLogo className="w-3.5 h-3.5" />
                           <span className="text-[10px] font-bold text-gray-500 tracking-wider mt-0.5">GOOGLE</span>
                        </div>
                      </div>
                      <p className="text-gray-600 text-sm italic leading-relaxed flex-grow line-clamp-4 mb-4">
                        "{review.text}"
                      </p>
                      <div className="flex items-center gap-3 mt-auto pt-4 border-t border-gray-200">
                        <div className="w-8 h-8 bg-gray-200 flex items-center justify-center text-gray-600 font-bold text-xs uppercase rounded-full">
                          {review.name.charAt(0)}
                        </div>
                        <span className="font-semibold text-gray-800 text-sm">{review.name}</span>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
            
            {/* Custom Navigation */}
            <div className="review-prev absolute left-0 lg:left-2 top-1/2 -translate-y-1/2 z-10 cursor-pointer text-gray-400 hover:text-orange transition-colors">
              <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7"></path></svg>
            </div>
            <div className="review-next absolute right-0 lg:right-10 top-1/2 -translate-y-1/2 z-10 cursor-pointer text-gray-400 hover:text-orange transition-colors">
              <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path></svg>
            </div>

            {/* Custom Pagination */}
            <div className="review-pagination absolute bottom-0 left-0 right-0 flex justify-center gap-2 z-10"></div>
          </div>
          
          {/* Tümünü Gör */}
          <div className="flex justify-center lg:justify-end pr-0 lg:pr-8 mt-4 mb-4 lg:mb-8">
            <a
              href="https://g.page/r/Cc84qp7cJY5HEBM/review"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary font-bold text-sm hover:text-orange transition-colors flex items-center gap-1"
            >
              {viewAllReviews}
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path></svg>
            </a>
          </div>

        </div>
      </div>
      <div className="flex-auto"></div>
    </div>
  );
};

export default Review;
